import { NumberFormatValues } from 'react-number-format';

export const isPositive = ({ value }: NumberFormatValues) => {
  if (value === '' || Number(value) >= 0) {
    return true;
  }

  return false;
};
